export const APP_NAME = 'Permafy';
